<template>
  <div class="content">
   
    <TranslateEmail> </TranslateEmail>
        
  </div>
</template>
<script>
   import TranslateEmail from '../../components/TranslateEmail/Translate_email'
  export default {
    components: {
      TranslateEmail,
    },
    data () {
      return {
        
      }
    },
    methods:{
    }
  }
</script>


<style>

</style>
